import useTypedSelector from '../../common/hook/useTypedSelector';
import {ISendEventParam, sendEvent} from '../../common/util/tracking';
interface IEventParam
  extends Pick<ISendEventParam, 'actionName' | 'customProps'> {}

export default function useEventPageEvent() {
  const eventId = useTypedSelector(
    state => state.event.moduleMap.event?.commonModule.questCampaignId
  );
  const sendEvent = (param: IEventParam) =>
    eventId && sendEventPageEvent(eventId, param);
  return sendEvent;
}

export function sendEventPageEvent(
  eventId: number,
  {actionName, customProps}: IEventParam
) {
  sendEvent({
    section: 'event_page',
    page: 'event_page',
    actionName,
    action: 'click',
    customProps: {...customProps, quest_campaign_id: eventId},
  });
}
